import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TbLockAccess } from "react-icons/tb";

import CommonPopup from "@/components/CommonPopup";
import { useUsersShowPasswordUpdateDialog, useUsersTableActions } from "@/stores/use-users-table";

import UserResetPasswordDialog from "./UserResetPasswordDialog";

function UserUpdateVehicleComp() {
    const { t } = useTranslation();
    const uservehicleUpdateInfo = useUsersShowPasswordUpdateDialog();
    const { updateShowPasswordUpdateDialog } = useUsersTableActions();
    const onClose = () => {
        updateShowPasswordUpdateDialog();
    };
    return (
        <CommonPopup
            title={t("buttons.resetUserPassword")}
            icon={TbLockAccess}
            open={!!uservehicleUpdateInfo}
            size="sm"
            onClose={onClose}
        >
            <>
                <Alert severity="info">Kullanıcının şifresini güncellemek için ilgili alanları doldurunuz.</Alert>
                <UserResetPasswordDialog />
            </>
        </CommonPopup>
    );
}

export default UserUpdateVehicleComp;
